/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const WorkState = {
    WithoutEvaluation: 'WithoutEvaluation',
    Passed: 'Passed',
    Warning: 'Warning',
    Failed: 'Failed',
    Open: 'Open',
    Skipped: 'Skipped'
} as const;
export type WorkState = typeof WorkState[keyof typeof WorkState];


export function WorkStateFromJSON(json: any): WorkState {
    return WorkStateFromJSONTyped(json, false);
}

export function WorkStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkState {
    return json as WorkState;
}

export function WorkStateToJSON(value?: WorkState | null): any {
    return value as any;
}

/**
 * Check if a given object implements the WorkState interface.
 */
 export function instanceOfWorkState(value: any): value is WorkState {
    return Object.values(WorkState).includes(value)
}

